/**
 * Staff legt eine Firma (Entleiher) vorab an — ohne Login-User (Slice 2 view).
 * Nutzt den rechtlichen Stammdaten-Step der Onboarding-Form. Reichere Felder
 * (Geschäftsführung, Billing, Vor-Ort) pflegt der Kunde später selbst bzw.
 * folgen als eigener Staff-Edit-Layer. Audit serverseitig (action `create`,
 * payload.onBehalf).
 */
import { upsertClientSchema, type UpsertClientInput } from '@hirebotiq-ops/core';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { trpc } from '../../lib/trpc.js';
import { Button } from '../ui/button.js';
import { ClientLegalEntityStep } from './ClientOnboardingForm.js';

const stripEmpty = (input: Record<string, unknown>): Record<string, unknown> => {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(input)) {
    if (v === '' || v === undefined || v === null) continue;
    if (Array.isArray(v) && v.length === 0) continue;
    out[k] = v;
  }
  return out;
};

export function StaffClientCreateForm({ onCreated }: { onCreated?: () => void }) {
  const utils = trpc.useUtils();
  const create = trpc.clients.staffCreate.useMutation({
    onSuccess: () => {
      toast.success('Firma angelegt.');
      utils.clients.list.invalidate();
      onCreated?.();
    },
    onError: (e) => toast.error(e.message),
  });

  const form = useForm<UpsertClientInput>({
    resolver: zodResolver(upsertClientSchema),
    defaultValues: {},
    mode: 'onBlur',
  });

  const onSubmit = async () => {
    const values = stripEmpty(form.getValues());
    try {
      await create.mutateAsync(values as UpsertClientInput);
      form.reset({});
    } catch {
      /* Fehler via onError getoastet */
    }
  };

  return (
    <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
      <ClientLegalEntityStep form={form} />
      <div className="flex justify-end">
        <Button onClick={onSubmit} disabled={create.isPending}>
          {create.isPending ? 'Lege an …' : 'Firma anlegen'}
        </Button>
      </div>
    </form>
  );
}
